<ng-container *ngIf="fg">
  <form [formGroup]="fg" class="grid grid-cols-12 gap-4">
    <div class="col-span-12 md:col-span-6 lg:col-span-4">
      <label for="GenerateBy" class="form-label">Generate by</label>
      <mat-select formControlName="GenerateBy" id="GenerateBy" class="form-control">
        <mat-option value="yearly">Yearly</mat-option>
        <mat-option value="monthly">Monthly</mat-option>
        <mat-option value="daily">Daily</mat-option>
      </mat-select>
    </div>

    <ng-container *ngIf="fg.controls.GenerateBy.value as type">

      <div *ngIf="type=='yearly'" class="col-span-12 md:col-span-6 lg:col-span-4">
        <label for="YearStart" class="form-label">Year Start</label>
        <mat-select formControlName="YearStart" id="YearStart" class="form-control">
          <mat-option *ngFor="let item of yearList$|async" [value]="item">{{item}}</mat-option>
        </mat-select>
      </div>
      <div *ngIf="type=='yearly'" class="col-span-12 md:col-span-6 lg:col-span-4">
        <label for="YearEnd" class="form-label">Year End</label>
        <mat-select formControlName="YearEnd" id="YearEnd" class="form-control">
          <mat-option *ngFor="let item of toYearList$|async" [value]="item">{{item}}</mat-option>
        </mat-select>
      </div>

      <div *ngIf="type=='monthly'||type=='daily'" class="col-span-12 md:col-span-6 lg:col-span-4">
        <label for="Year" class="form-label">Year</label>
        <mat-select formControlName="Year" id="Year" class="form-control">
          <mat-option *ngFor="let item of yearList$|async" [value]="item">{{item}}</mat-option>
        </mat-select>
      </div>

      <div *ngIf="type=='daily'" class="col-span-12 md:col-span-6 lg:col-span-4">
        <label for="Month" class="form-label">Month</label>
        <mat-select formControlName="Month" id="Month" class="form-control">
          <mat-option *ngFor="let item of monthList$|async" [value]="item.number">{{item.name|titlecase}}</mat-option>
        </mat-select>
      </div>

    </ng-container>

  </form>
</ng-container>